// import { useState } from "react";
import img from "./Images/MovieCamera.webp";
import "./Header.css";
const Header = (props) => {
  return (
    <div>
      <div classNameName="container-fluid" id="headback">
        <div className="container-fluid p-0">
          <div classNameName="row">
            <div classNameName="col-12 p-0 ">
              <nav className="navbar navbar-expand-lg">
                <div className="container-fluid">
                  <a className="navbar-brand" href="#">
                    <img src={img} className="" id="headimg" />
                    <span className="ms-3 text-white">
                      <span className="text-danger">MOVIE</span> REVIEW
                    </span>
                  </a>
                  <button
                    className="navbar-toggler text-white"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon text-white"></span>
                  </button>
                  <div
                    className="collapse navbar-collapse"
                    id="navbarSupportedContent"
                  >
                    <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                      <li className="nav-item ms-lg-5">
                        <a
                          className="nav-link active text-white"
                          aria-current="page"
                          href="#"
                        >
                          Home
                        </a>
                      </li>
                      <li className="nav-item ms-lg-5">
                        <a className="nav-link active text-white" href="#">
                          Director
                        </a>
                      </li>
                      <li className="nav-item ms-lg-5">
                        <a className="nav-link active text-white" href="#">
                          Gallary
                        </a>
                      </li>
                      <li className="nav-item ms-lg-5">
                        <a className="nav-link active text-white" href="#">
                          Pages
                        </a>
                      </li>
                      <li className="nav-item ms-lg-5">
                        <a className="nav-link active text-white" href="#">
                          Blog
                        </a>
                      </li>
                      <li className="nav-item ms-lg-5">
                        <a className="nav-link active text-white" href="#">
                          Contact
                        </a>
                      </li>
                    </ul>

                    <a href="https://www.imdb.com/" target="_blank">
                      {/* <button
                        className="btn bg-danger text-white me-5"
                        type="submit"
                      >
                        MORE VIDEOS
                      </button> */}
                      <button type="button" class="btn btn-danger">MORE VIDEOS</button>
                    </a>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
